import { render, staticRenderFns } from "./ReportsNew.vue?vue&type=template&id=366fe785&scoped=true&"
import script from "./ReportsNew.vue?vue&type=script&lang=js&"
export * from "./ReportsNew.vue?vue&type=script&lang=js&"
import style0 from "./ReportsNew.vue?vue&type=style&index=0&id=366fe785&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366fe785",
  null
  
)

export default component.exports